import { EnumMembershipType, EnumStyle } from '../../../../../lib/database/lib/generated/enums'

export const STYLE_NAME: Record<keyof typeof EnumStyle, string> = {
  [EnumStyle.FLAT_VECTOR]: 'Flat Vector',
  [EnumStyle.FLAT_VECTOR_OUTLINE]: 'Flat Vector Outline',
  [EnumStyle.FLAT_VECTOR_SILHOUETTE]: 'Flat Vector Silhouette',
  [EnumStyle.FLAT_VECTOR_ONE_LINE_ART]: 'Flat Vector One Line Art',
  [EnumStyle.FLAT_VECTOR_LINE_ART]: 'Flat Vector Line Art',
} as const

export const MEMBERSHIP_TYPE_NAME: Record<keyof typeof EnumMembershipType, string> = {
  [EnumMembershipType.LITE]: 'Lite',
  [EnumMembershipType.PRO]: 'Pro',
  [EnumMembershipType.PREMIUM]: 'Premium',
} as const

export const STRIPE_PORTAL_MANAGE_SUBSCRIPTION_LINK =
  process.env['SVGIO_STAGE'] === 'prod'
    ? 'https://billing.stripe.com/p/login/fZe4iU3Ib2Pd5pe4gg'
    : 'https://billing.stripe.com/p/login/test_cN2g2mbyP0O41qM8ww'
